import TIM from '@tencentcloud/chat'
import TIMUploadPlugin from 'tim-upload-plugin'

// 初始化IM
export const initIM = (SDKAppID) => {
  const options = {
    SDKAppID,
    level: TIM.TYPES.LOG_LEVEL // 日志级别
  }

  const tim = TIM.create(options)

  // 注册插件
  tim.registerPlugin({ 'tim-upload-plugin': TIMUploadPlugin })

  // 设置日志级别
  tim.setLogLevel(1)

  return tim
}

export const loginIM = async(tim, userID, userSig) => {
  return tim.login({ userID, userSig })
}

export const getConversationList = (tim) => {
  return tim.getConversationList()
}

export const getMessageList = (tim, options) => {
  return tim.getMessageList(options)
}

export const sendMessage = (tim, message) => {
  return tim.sendMessage(message)
}
